import {initialUserState} from "../states/userState.state";
import {createReducer, on} from "@ngrx/store";
import { setConnectedUser, setIsAcepPartner, setIsMandataire, setIsPartnerAdmin, setUserCustomer, setUserPartner, setUserPreference, setUserPreferences } from '../actions/user.action';


export const userReducer = createReducer(
  initialUserState,
  on(setConnectedUser, (state, { user }) => (
    {
      ...state,
      connectedUser: user
    }
  )),
  on(setIsPartnerAdmin, (state, { isPartnerAdmin }) => (
    {
      ...state,
      isPartnerAdmin
    }
  )),
  on(setIsMandataire, (state, { isMandataire }) => (
    {
      ...state,
      isMandataire
    }
  )),
  on(setIsAcepPartner, (state, { isAcepPartner }) => (
    {
      ...state,
      isAcepPartner
    }
  )),
  on(setUserPartner, (state, { userPartner }) => (
    {
      ...state,
      userPartner
    }
  )),
  on(setUserCustomer, (state, { userCustomer }) => (
    {
      ...state,
      userCustomer
    }
  )),
  on(setUserPreferences, (state, { userPreferences }) => (
    {
      ...state,
      userPreferences
    }
  )),
  on(setUserPreference, (state, { code, value }) => (
    {
      ...state,
      userPreferences: { ...(state.userPreferences ?? {}), [code]: value }
    }
  ))
);
